import React from 'react'
import ChromePopupApp from './Chrome/PopupApp'

export default function Sandbox() {
  return <ChromePopupApp />
}
